import { Flex, Space } from "@mantine/core";

function NullCell() {
  return (
    <Flex align="center" justify="flex-end">
      –
      <Space h={28} w={28} />
    </Flex>
  );
}

export { NullCell };
